import React from 'react';
import { motion } from 'framer-motion';
import { Repeat, TrendingUp, PieChart } from 'lucide-react';
export function BusinessModelSlide() {
  return <div className="h-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-19">
      <div className="space-y-8" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="p-6 rounded-2xl bg-purple-50 border border-purple-200" data-id="element-21">
          <div className="flex items-center gap-3 mb-4" data-id="element-22">
            <Repeat className="w-6 h-6 text-purple-600" data-id="element-23" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-24">
              Recurring Runtime Revenue
            </h3>
          </div>
          <ol className="text-gray-600 space-y-2 list-decimal list-inside" data-id="element-25">
            <li data-id="element-26">Snak Master creation</li>
            <li data-id="element-27">Localization license, per 6 months per country per Snak</li>
            <li data-id="element-28">Insight analytics per snak/month/country</li>
          </ol>
        </motion.div>

        <div className="grid grid-cols-2 gap-4" data-id="element-29">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2
        }} className="p-5 rounded-xl bg-gray-50 border border-gray-200" data-id="element-30">
            <div className="text-green-600 text-2xl font-bold mb-1" data-id="element-31">70–90%</div>
            <div className="text-sm text-gray-500" data-id="element-32">Cost Savings</div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3
        }} className="p-5 rounded-xl bg-gray-50 border border-gray-200" data-id="element-33">
            <div className="text-purple-600 text-2xl font-bold mb-1" data-id="element-34">2–5x</div>
            <div className="text-sm text-gray-500" data-id="element-35">Higher ROI</div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="flex items-center gap-4 p-4 rounded-xl bg-blue-50 border border-blue-200" data-id="element-36">
          <PieChart className="w-8 h-8 text-blue-600" data-id="element-37" />
          <div data-id="element-38">
            <div className="text-lg font-bold text-gray-900" data-id="element-39">60%+ Margins</div>
            <div className="text-sm text-gray-500" data-id="element-40">
              80% AI Automated Production
            </div>
          </div>
        </motion.div>
      </div>

      <div className="relative h-[400px] flex items-center justify-center" data-id="element-41">
        {/* Flywheel Visualization */}
        <div className="relative w-80 h-80" data-id="element-42">
          <motion.div animate={{
          rotate: 360
        }} transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear'
        }} className="absolute inset-0 rounded-full border-2 border-dashed border-gray-200" data-id="element-43" />
          <motion.div animate={{
          rotate: -360
        }} transition={{
          duration: 30,
          repeat: Infinity,
          ease: 'linear'
        }} className="absolute inset-8 rounded-full border border-purple-300" data-id="element-44" />

          {/* Center Content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center z-10" data-id="element-45">
            <div className="w-24 h-24 rounded-full bg-purple-100 backdrop-blur-md flex items-center justify-center border border-purple-300 shadow-lg shadow-purple-100" data-id="element-46">
              <TrendingUp className="w-10 h-10 text-purple-600" data-id="element-47" />
            </div>
          </div>

          {/* Satellites */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white border border-gray-200 px-3 py-1 rounded-full text-xs text-gray-600 whitespace-nowrap shadow-sm" data-id="element-48">
            Outcome Aligned
          </div>
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 bg-white border border-gray-200 px-3 py-1 rounded-full text-xs text-gray-600 whitespace-nowrap shadow-sm" data-id="element-49">
            High Retention
          </div>
          <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white border border-gray-200 px-3 py-1 rounded-full text-xs text-gray-600 whitespace-nowrap shadow-sm" data-id="element-50">
            Scalable
          </div>
          <div className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 bg-white border border-gray-200 px-3 py-1 rounded-full text-xs text-gray-600 whitespace-nowrap shadow-sm" data-id="element-51">
            Sticky
          </div>
        </div>
      </div>
    </div>;
}